'use client';

import { createContext, useContext } from 'react';
import type { Project } from '@frameio/graphql-client/generated';

type ProjectId = Project['id'] | undefined;

export const IsolatedActiveProjectIdContext =
  createContext<ProjectId>(undefined);

export const useActiveProjectId = () =>
  useContext(IsolatedActiveProjectIdContext);

type IsolatedActiveProjectContextProviderProps = {
  children: React.ReactNode;
  projectId?: ProjectId;
};

export const IsolatedActiveProjectIdContextProvider = ({
  projectId,
  children,
}: IsolatedActiveProjectContextProviderProps) => {
  return (
    <IsolatedActiveProjectIdContext.Provider value={projectId}>
      {children}
    </IsolatedActiveProjectIdContext.Provider>
  );
};
